import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { H2, H3 } from "../components/Heading";
import { Paragraph } from "../components/Paragraph";
import { Box } from "../components/Box";
import { NewMonitoringRecordFrame } from "./NewMonitoringRecord/NewMonitoringRecordFrame";
import { useIndividual } from "../data/useIndividual";
import { Card } from "../components/Card";
import { Flex } from "../components/Flex";
import { capitalise } from "../utils/string";
import { Button } from "../components/Button";
import { DateTime } from "luxon";

const Heading = styled(H3)`
  ${({ theme: { fontSizes } }) => `
    font-size: ${fontSizes[2]};
    word-break: break-all;
  `}
`;

const CardLine = ({ children, ...styleProps }: any) => (
  <Paragraph fontSize={1} color="gray.60" my={0} {...styleProps}>
    {children}
  </Paragraph>
);
const Header = () => {
  return (
    <>
      <H2>Confirm Individuals Details</H2>
      <Paragraph>
        Please select set of details you would like to proceed.
      </Paragraph>
    </>
  );
};

export const ApplicationsActivateMonitoringIndividual = () => {
  const params = useParams();
  const navigate = useNavigate();

  const { data: individualData } = useIndividual(params.id);
  const individual = individualData?.data;

  return (
    <>
      <NewMonitoringRecordFrame step="individual">
        <Header />
        <Card>
          <Flex gap="12">
            <Box
              flex={4}
              borderColor="gray.20"
              width={"50%"}
            >
              <Heading mb={2}>Personal Details</Heading>
              

              <Flex gap="24">
                <Box flex={1}>
                  <CardLine>First name</CardLine>
                  <Heading>
                    {individual?.personal_detail?.first_name
                      ? individual?.personal_detail?.first_name
                      : "-"}
                  </Heading>
                </Box>
                <Box flex={1}>
                  <CardLine>Middle name</CardLine>
                  <Heading>
                    {individual?.personal_detail?.middle_name
                      ? individual?.personal_detail?.middle_name
                      : "-"}
                  </Heading>
                </Box>
                <Box flex={1}>
                  <CardLine>Last name</CardLine>
                  <Heading>
                    {individual?.personal_detail?.last_name
                      ? individual?.personal_detail?.last_name
                      : "-"}
                  </Heading>
                </Box>
              </Flex>
              <Flex gap="24" marginTop={2}>
                <Box flex={1}>
                  <CardLine>Date of birth</CardLine>
                  <Heading>
                    {individual?.personal_detail?.date_of_birth
                      ? DateTime.fromISO(
                        individual?.personal_detail?.date_of_birth
                      ).toFormat("dd/MM/yyyy")
                      : "-"}
                  </Heading>
                </Box>
                <Box flex={1}>
                  <CardLine>Gender</CardLine>
                  <Heading>
                    {individual?.personal_detail?.gender
                      ? capitalise(individual?.personal_detail?.gender)
                      : "-"}
                  </Heading>
                </Box>
                <Box flex={1}>
                  <CardLine>Title</CardLine>
                  <Heading>
                    {individual?.personal_detail?.title ? individual?.personal_detail?.title : "-"}
                  </Heading>
                </Box>
              </Flex>
            </Box>
          </Flex>
        </Card>

        <Flex justifyContent="space-between">
            <Button
              size="large"
              mt="2"
              mb="0"
              variant="secondary"
              onClick={() =>
                navigate(`/applications/${individual.mandate}/individuals/${individual.id}`)
              }
            >
              Cancel
            </Button>
            <Button
              size="large"
              mt="2"
              mb="2"
              type="submit"
              onClick={() =>
                navigate(`/applications/${individual.mandate}/activate-monitoring/${individual.id}`)
              }
            >
              Next
            </Button>
        </Flex>
      </NewMonitoringRecordFrame>
    </>
  );
}